import React from 'react';
import PropTypes from 'prop-types';

import { ButtonOutlined, SvgIcon, Text, Flex } from 'Components/Base';

const InformationButton = ({ title, icon, onClick, ...props }) => {
  return (
    <ButtonOutlined
      width={'100%'}
      height={48}
      borderRadius={2}
      color={'greyscale.grey4'}
      onClick={onClick}
      {...props}
    >
      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <Flex alignItems={'center'}>
          <SvgIcon icon={icon} size={20} color={'primaryLight'} mr={2} />
          <Text textStyle={'body1Medium'} color={'text'}>
            {title}
          </Text>
        </Flex>
        <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_RIGHT} size={20} color={'greyscale.grey1'} />
      </Flex>
    </ButtonOutlined>
  );
};

InformationButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  icon: PropTypes.object,
};

export default InformationButton;
